export interface ApiLog {
    id: string,
    url: string,
    ip: string,
    date: Date,
    method: string,
    user_agent?: string,
    tenant_name?: string,
    tenant_id?: string,
    response?: string,
    request_body?: string,
    latency: number,
    response_code: number,
    response_content: string,
    private_key: string,
    public_key: string,
}

export interface ApiLogs {
    items: ApiLog[],
    total: number
}

export interface ApiLogsListParams {
    date: string,
    id: string,
    tenant: string,
    method: string,
    url: string,
    response_code: string,
    ip_address: string,
}

export let METHODS = ['GET', 'PUT', 'POST', 'DELETE', 'PATCH'];